export const PUBLIC_VP_PRICE_REFRESH_REQUIRED = "PRICE_REFRESH_REQUIRED";
export const PUBLIC_VP_PRICE_REFRESH_MESSAGE_HE =
  "מחיר החבילה השתנה או שפג תוקפו. אנא חזרו לתוצאות ורעננו את החיפוש.";

function firstNonEmptyString(candidates) {
  for (const value of candidates) {
    if (value == null) continue;
    const text = String(value).trim();
    if (text) return text;
  }
  return null;
}

function asObject(value) {
  return value && typeof value === "object" && !Array.isArray(value) ? value : null;
}

/**
 * Server-generated public VP snapshot id. Never invent one on the client.
 */
export function extractPublicVacationPackageSnapshotId(source) {
  const root = asObject(source);
  if (!root) return null;
  const full = asObject(root.fullDeal) || {};
  const our = asObject(root.ourPrice) || asObject(full.ourPrice) || {};
  return firstNonEmptyString([
    root.pricing_snapshot_id,
    root.pricingSnapshotId,
    root.public_pricing_snapshot_id,
    full.pricing_snapshot_id,
    full.pricingSnapshotId,
    our.pricing_snapshot_id,
    our.pricingSnapshotId,
  ]);
}

export function extractPublicVacationPackageCustomerPrice(source) {
  const root = asObject(source);
  if (!root) return null;
  const full = asObject(root.fullDeal) || {};
  const n = Number(
    root.public_customer_price ??
      root.publicCustomerPrice ??
      full.public_customer_price ??
      full.publicCustomerPrice
  );
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function attachPublicVacationPackageSnapshotFields(target, source) {
  const dest = asObject(target);
  if (!dest) return null;
  const snapshotId =
    extractPublicVacationPackageSnapshotId(source) || extractPublicVacationPackageSnapshotId(dest);
  const publicPrice =
    extractPublicVacationPackageCustomerPrice(source) ??
    extractPublicVacationPackageCustomerPrice(dest);
  if (snapshotId) {
    dest.pricing_snapshot_id = snapshotId;
    if (asObject(dest.fullDeal)) {
      dest.fullDeal.pricing_snapshot_id = snapshotId;
    }
  }
  if (publicPrice != null) {
    dest.public_customer_price = publicPrice;
    if (asObject(dest.fullDeal)) {
      dest.fullDeal.public_customer_price = publicPrice;
    }
  }
  return snapshotId;
}

export function assertPublicVacationPackageSnapshotId(source) {
  const snapshotId = extractPublicVacationPackageSnapshotId(source);
  if (!snapshotId) {
    const err = new Error(PUBLIC_VP_PRICE_REFRESH_MESSAGE_HE);
    err.code = PUBLIC_VP_PRICE_REFRESH_REQUIRED;
    throw err;
  }
  return snapshotId;
}

export function isPublicPriceRefreshRequiredError(err) {
  const payload = err?.response?.data || err?.data || err || {};
  const code = String(payload.code || err?.code || "").trim();
  const error = String(payload.error || payload.error_code || "").trim();
  const reason = String(payload.reason || "").trim();
  return (
    code === "PRICE_SNAPSHOT_MISSING" ||
    code === "PRICE_SNAPSHOT_EXPIRED" ||
    code === "PRICE_CHANGED" ||
    code === "PRICE_SNAPSHOT_MISMATCH" ||
    code === PUBLIC_VP_PRICE_REFRESH_REQUIRED ||
    error === "PRICE_REFRESH_REQUIRED" ||
    reason === "PRICE_SNAPSHOT_MISSING" ||
    reason === "PRICE_SNAPSHOT_EXPIRED" ||
    reason === "PRICE_CHANGED" ||
    reason === "PRICE_SNAPSHOT_MISMATCH"
  );
}

export function publicPriceRefreshErrorFromResponse(err) {
  const wrapped = new Error(PUBLIC_VP_PRICE_REFRESH_MESSAGE_HE);
  wrapped.code = PUBLIC_VP_PRICE_REFRESH_REQUIRED;
  wrapped.cause = err;
  return wrapped;
}

/**
 * Forward a server-issued snapshot id when present. Never invent one.
 * Public /searchLds does not currently stamp pricing_snapshot_id, and
 * createLdsNewOrder does not require it — pay must proceed without it.
 * Use required:true only when a snapshot was already attached (tests / continuity).
 */
export function resolvePublicCreateLdsSnapshotFields(selectedResult, { required = false } = {}) {
  const snapshotId = extractPublicVacationPackageSnapshotId(selectedResult);
  if (!snapshotId) {
    if (required) {
      assertPublicVacationPackageSnapshotId(selectedResult);
    }
    return {};
  }
  return { pricing_snapshot_id: String(snapshotId) };
}
